import { defineQuery } from 'next-sanity';

export const getRandomTestimonial = defineQuery(`
  *[_type == "testimonial" && includeInRandom == true] {
        name,
        content,
        country
  }[$randomIndex]
  `);

export const getRecentBlogPost = defineQuery(`
*[_type ==$blogType && ($excludeIds == null || !(_id in $excludeIds))] | order(coalesce(editedDate, _updatedAt) desc) [0...3]{
      _id,
    title,
    coverMedia {
      ...,
      coverImage {
        ...,
        "imgAsset": asset-> {
          ...
        }
      },
      thumbnail{
        ...,
        "imgAsset": asset-> {
          ...
        }
      }
    },
    slug,
   }
  `);

export const getAllCategories = defineQuery(
  `*[_type==$categoryType && (status == true || status == null) ] | order(title asc){
      _id,
      title,
      slug{
        current
      },
      categoryTitle,
    }`
);

// ========== Search Result page ==========
// @sanity-typegen-ignore
export const searchPage = defineQuery(`
{
"searchData": *[_type in ["blog", "caseStudy","news","resource","faq"] && title match $searchValue] | order(_createdAt desc)[($page - 1) * $limit...$page * $limit] {
title,
_type,
_createdAt,
slug,
content,
category->{
  title,
},    
},
 "total": count(*[_type in ["blog", "caseStudy","news","resource","faq"] && title match $searchValue])
}
`);

// ========== redirect Result page ==========
export const REDIRECTS_QUERY = defineQuery(`
  *[_type == "redirect" && isEnabled == true] {
      source,
      destination,
      permanent
  }
`);
